import callsLogo from '../../assets/logos/calls.svg';
import { IntegrationCard } from './IntegrationCard';
import { voiceHealth, type IntegrationsState } from './model';

/**
 * Outbound calls, shown only when this host has them on (test or live). Turning calls live is a founder decision made in
 * the host settings (docs/deploy/voice.md), so the card explains the state and offers no switch.
 */
export function CallsCard({ mode }: { mode: NonNullable<IntegrationsState['voiceMode']> }) {
  const summary = mode === 'live'
    ? 'Alder calls customers who have not answered email, within your policy, and logs every call on the customer.'
    : 'Alder can call customers who have not answered email.';
  return <IntegrationCard id="calls" logo={callsLogo} name="Calls" role="Phone follow-up · voice agent" health={voiceHealth(mode)}
    summary={summary} facts={[]}/>;
}
